module.exports = __webpack_public_path__ + "static/media/page-image.a04a0ab1.jpg";